import { createSlice } from "@reduxjs/toolkit";

const initialBcfState = {
  currentBcfId: "",
  bcfData: null,
  isAutoBcfLoaded: false,
};

const itemsHaveErrorSlice = createSlice({
  name: "itemsHaveError",
  initialState: false,
  reducers: {
    setItemsHaveError: (_state, action) => action.payload,
  },
});

const itemsAreLoadingSlice = createSlice({
  name: "itemsAreLoading",
  initialState: false,
  reducers: {
    setItemsAreLoading: (_state, action) => action.payload,
  },
});

const itemsSlice = createSlice({
  name: "items",
  initialState: [],
  reducers: {
    setItems: (_state, action) => action.payload,
  },
});

const bcfDataSlice = createSlice({
  name: "bcfData",
  initialState: initialBcfState,
  reducers: {
    saveBcfData: (state, action) => {
      if (action.payload) {
        state.currentBcfId = action.payload;
      }
    },
    setBcfBufferData: (state, action) => {
      if (action.payload) {
        state.bcfData = action.payload;
      }
    },
    setAutoBcfLoaded: (state, action) => {
      if (action.payload !== undefined) {
        state.isAutoBcfLoaded = action.payload;
      }
    },
  },
});

export const { setItemsHaveError } = itemsHaveErrorSlice.actions;
export const { setItemsAreLoading } = itemsAreLoadingSlice.actions;
export const { setItems } = itemsSlice.actions;
export const { saveBcfData, setBcfBufferData, setAutoBcfLoaded } = bcfDataSlice.actions;

export const itemsHaveError = itemsHaveErrorSlice.reducer;
export const itemsAreLoading = itemsAreLoadingSlice.reducer;
export const items = itemsSlice.reducer;
export const bcfData = bcfDataSlice.reducer;
